import React, { Component } from 'react';
import Router from './shared/Router';

import './vendor/styles/bootstrap-material.scss';
import './vendor/styles/appwork-material.scss';
import './vendor/styles/theme-soft-material.scss';
import './vendor/styles/colors-material.scss';
import './vendor/styles/uikit.scss';
import './App.scss';

class App extends Component {
  render() {
    return <Router />;
  }
}

export default App;
